import { communitySocialMedias } from '@/constants/community-social-media';
import useSidebarVariant from '@/hooks/theme/variants/useSidebarVariant';
import { RootState } from '@/lib/store';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import SideBarItemSocialMedia from './SocialMedia';
import styles from './styles.module.scss';

export default function SideBarItemSocialMedias() {
  const { isV3Version } = useSidebarVariant();
  const isCollapsed = useSelector(
    (state: RootState) => state.sideBar.collapsed,
  );

  const socialMedias = useMemo(() => {
    return communitySocialMedias.map(socialMedia => (
      <SideBarItemSocialMedia
        key={`social-media-${socialMedia.faIcon}`}
        href={socialMedia.href}
        faIcon={socialMedia.faIcon}
      />
    ));
  }, []);

  if (!isV3Version) return null;

  return (
    <div
      className={`${styles.container} ${isCollapsed ? styles['container--collapsed'] : ''}`}
    >
      {socialMedias}
    </div>
  );
}
